//社交管理
export default [
  {
    path: '/communityIntroduce',
    component: () => import('../pages/community/communityIntroduce.vue'),
    name: 'communityIntroduce',
    title: '社群信息',
    meta: {
      title: '社群信息',
    },
  },
  {
    path: '/communityCategory',
    component: () => import('../pages/community/communityCategory.vue'),
    name: 'communityCategory',
    title: '社群分类',
    meta: {
      title: '社群分类',
    },
  },
  {
    path: '/communityManage',
    component: () => import('../pages/community/communityManage.vue'),
    name: 'communityManage',
    title: '社群管理',
    meta: {
      title: '社群管理',
    },
  },
  {
    path: '/community/resumeDetail',
    component: () => import('../pages/community/volunteer/resumeDetail.vue'),
    name: 'communityresumeDetail',
    title: '简历详情',
    meta: {
      title: '简历详情',
    },
  },
  {
    path: '/community/resumeManage',
    component: () => import('../pages/community/volunteer/resumeManage.vue'),
    name: 'communityresumeManage',
    title: '简历管理',
    meta: {
      title: '简历管理',
    },
  },
  {
    path: '/community/serveAppointment',
    component: () =>
      import('../pages/community/volunteer/serveAppointment.vue'),
    name: 'communityserveAppointment',
    title: '预约记录',
    meta: {
      title: '预约记录',
    },
  },
  {
    path: '/community/serveGroup',
    component: () => import('../pages/community/volunteer/serveGroup.vue'),
    name: 'communityserveGroup',
    title: '服务分组',
    meta: {
      title: '服务分组',
    },
  },
  {
    path: '/community/signInStatistics',
    component: () =>
      import('../pages/community/volunteer/signInStatistics.vue'),
    name: 'communitysignInStatistics',
    title: '签到统计',
    meta: {
      title: '签到统计',
    },
  },
  {
    path: '/community/volunteerRecruitment',
    component: () =>
      import('../pages/community/volunteer/volunteerRecruitment.vue'),
    name: 'communityvolunteerRecruitments',
    title: '志愿者招募',
    meta: {
      title: '志愿者招募',
    },
  },
  {
    path: '/community/volunteerWall',
    component: () => import('../pages/community/volunteer/volunteerWall.vue'),
    name: 'communityvolunteervolunteerWall',
    title: '志愿者墙管理',
    meta: {
      title: '志愿者墙管理',
    },
  },
  {
    path: '/community/preSignManage',
    component: () => import('../pages/community/preSignManage.vue'),
    name: 'communitypreSignManage',
    title: '会长签到记录',
    meta: {
      title: '会长签到记录',
    },
  },
]
